/**
 * Hide unopened navigation items on collection pages
 * Handles both 2-layer and 3-layer navigation structures
 */

$(document).ready(function() {
    // Check if we're on a collection page (but NOT /collections/all)
    if (window.location.pathname.includes('/collections/') && window.location.pathname !== '/collections/all') {
        
        // First, check if any navPages-item has is-clicked
        var hasClickedItem = $('.navPages-item.is-clicked').length > 0;

        if (!hasClickedItem) {
            // No top-level item is marked as clicked
            // Try to find the matching item based on URL
            var currentPath = window.location.pathname;
            
            // Try to find exact match in navPages-item first
            $('.navPages-item a.navPages-action').each(function() {
                var href = $(this).attr('href');
                if (href && currentPath.includes(href)) {
                    $(this).closest('.navPages-item').addClass('is-clicked');
                    return false; // break
                }
            });
            
            // If still no match, try to find in any child link
            if ($('.navPages-item.is-clicked').length === 0) {
                $('.navPage-subMenu-item a').each(function() {
                    var href = $(this).attr('href');
                    if (href && currentPath.includes(href)) {
                        // Mark the child as clicked
                        $(this).closest('.navPage-subMenu-item').addClass('is-clicked');
                        // Mark the parent navPages-item as clicked
                        $(this).closest('.navPages-item').addClass('is-clicked');
                        return false; // break
                    }
                });
            }
        }
        
        // SIMPLE LOGIC: Only hide top-level navPages-item that are NOT clicked
        // Show ALL descendants of clicked top-level items
        $('.navPages-item:not(.is-clicked)').hide();
        
        // Make sure all descendants of clicked items are visible
        $('.navPages-item.is-clicked').find('.navPage-subMenu-item').show();

        // Hide category filter if no items to show
        if($('.navPages-item.is-clicked').find('.navPage-subMenu-item').length == 0){
            $('.sidebar-categories').hide();
        }
        
        // Add smooth transition effect
        $('.navPages-item.is-clicked, .navPage-subMenu-item.is-clicked').css({
            'display': 'list-item',
            'opacity': '1'
        });
    }
    
    // ==========================================
    // Vertical Menu - Open on Hover
    // ==========================================
    
    const $verticalMenu = $('.vertical-menu.p-relative.sticky_effect');
    
    // Open menu on mouse enter
    $verticalMenu.on('mouseenter', function() {
        $(this).removeClass('vertical-menu__hide');
        $(this).addClass('vertical-menu__open');
    });
    
    // Close menu on mouse leave
    $verticalMenu.on('mouseleave', function() {
        $(this).removeClass('vertical-menu__open');
        $(this).addClass('vertical-menu__hide');
    });
});




function scrollToDescription(event) {
    event.preventDefault();
    
    // Remove is-active class from all tabs and tab contents
    $('.tabs .tab').removeClass('is-active');
    $('.tabs-contents .tab-content').removeClass('is-active');
    
    // Find and activate the descriere tab
    var descriereTab = $('#tab-descriere');
    var descriereTabLink = $('a[href="#tab-descriere"]').parent('.tab');
    
    // Activate the descriere tab link
    if (descriereTabLink.length) {
        descriereTabLink.addClass('is-active');
    }
    
    // Activate the descriere tab content
    if (descriereTab.length) {
        descriereTab.addClass('is-active');
        
        // Scroll to the tab with offset
        var offset = 150;
        var targetPosition = descriereTab.offset().top - offset;
        
        $('html, body').animate({
            scrollTop: targetPosition
        }, 600); // 600ms animation duration
    }
}

